// News

export const POSTS_RELATED_LIMIT = 3;
export const NEWS_PAGE_SIZE = 5;

const fieldsList = 'fields[]=id,link,image.filename_disk,title,description,publish_at';
const allOtherFields = 'content_description,content,meta_title,meta_description,facebook_link,linkedin_link';
const meta = 'meta=*';

export const CMS_ALL_NEWS_ENDPOINT = (page: number, params: string, limit?: number) => {
  return `/items/u1_news_posts?filter[status][_eq]%=published&${fieldsList}&${meta}&sort[]=sort&sort[]=-publish_at&limit=${
    limit ? limit : NEWS_PAGE_SIZE
  }&${params}&offset=${(page - 1) * NEWS_PAGE_SIZE}`;
};

export const CMS_ONE_POST_ENDPOINT = (link: string): string =>
  `/items/u1_news_posts?filter[link][_eq]=${link}&filter[status][_in]=published,draft&${fieldsList},${allOtherFields}`;

// Careers

export const CAREERS_PAGE_SIZE = 7;

const careersList =
  'fields[]=id,title,link,description,publish_at,location.id,location.name,location.state.short_name,jobtype.id,jobtype.name,years_in_industry,category.u1_careers_categories_id.*';
const allOtherCareers = 'experience.u1_careers_experience_id.title,requirements.u1_careers_requirements_id.title,details';
const metaCareers = 'meta=*';

export const CMS_ALL_CAREERS_ENDPOINT = `/items/u1_careers?filter[status][_eq]%=published&${careersList}&${metaCareers}&sort[]=sort&sort[]=-publish_at`;
export const CMS_ALL_CAREERS_CATEGORIES_ENDPOINT = '/items/u1_careers_categories?sort=sort';
export const CMS_ALL_CAREERS_CITIES_ENDPOINT = '/items/u1_cities?fields[]=id, name, state.short_name, u1_careers&sort=name';
export const CMS_ALL_CAREERS_TYPES_ENDPOINT = '/items/u1_careers_type?sort=id';
export const CMS_ALL_CAREERS_TITLES_ENDPOINT = '/items/u1_careers?fields[]=title';

export const CMS_ONE_CAREER_ENDPOINT = (link: string): string =>
  `/items/u1_careers?filter[link][_eq]=${link}&filter[status][_in]=published,draft&${careersList},${allOtherCareers}`;
